export default __webpack_public_path__ + "ce1c851d28db62ce94a8332f79524b5b.png";